(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Mobile menu & search toggles */
  $$('[data-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('data-toggle'));
      if (!target) return;
      var open = target.hasAttribute('hidden');
      if (open) target.removeAttribute('hidden'); else target.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var input = $('input', target); if (input && target.id === 'HeaderSearch') input.focus(); }
    });
  });

  /* Cart count + toast */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count > 0 ? count : ''; });
  }
  var toastTimer;
  function toast(msg, withLink) {
    var t = $('#CartToast'); if (!t) return;
    t.innerHTML = '';
    var span = document.createElement('span'); span.textContent = msg; t.appendChild(span);
    if (withLink) { var a = document.createElement('a'); a.href = window.theme.routes.cart; a.textContent = window.theme.strings.view; t.appendChild(a); }
    t.removeAttribute('hidden');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.setAttribute('hidden', ''); }, 4500);
  }

  /* AJAX add to cart (falls back to native form post without JS) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-ajax-cart]')) return;
    e.preventDefault();
    var btn = $('[type=submit]', form); if (btn) btn.disabled = true;
    fetch(window.theme.routes.cart_add + '.js', {
      method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || window.theme.strings.error);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) { updateCount(cart.item_count); toast(window.theme.strings.added, true); })
      .catch(function (err) { toast(err.message || window.theme.strings.error, false); })
      .finally(function () { if (btn) btn.disabled = btn.hasAttribute('data-sold-out'); });
  });

  /* Quantity buttons */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]'); if (!b) return;
    var input = $('input', b.parentNode); if (!input) return;
    var v = parseInt(input.value, 10) || 0;
    var min = parseInt(input.min, 10); if (isNaN(min)) min = 0;
    input.value = Math.max(min, v + (b.getAttribute('data-qty') === 'plus' ? 1 : -1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart page: auto-submit on quantity change */
  $$('[data-cart-form] input[name="updates[]"]').forEach(function (i) {
    i.addEventListener('change', function () { clearTimeout(i._t); i._t = setTimeout(function () { i.form.submit(); }, 500); });
  });

  /* Product page: variants & gallery */
  $$('[data-product]').forEach(function (root) {
    var dataEl = $('[data-product-json]', root); if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = $('form[data-product-form]', root);
    var idInput = $('input[name=id]', form);
    var addBtn = $('[data-add-button]', root);
    var priceEl = $('[data-price]', root);
    var availEl = $('[data-availability]', root);
    var mainImg = $('[data-main-image]', root);
    var money = function (cents) {
      try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: root.getAttribute('data-currency') }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2); }
    };
    function selected() {
      return $$('fieldset.option', root).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function setImage(src, id) {
      if (!mainImg || !src) return;
      mainImg.src = src; mainImg.removeAttribute('srcset');
      $$('.product__thumbs button', root).forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-media-id') == id ? 'true' : 'false'); });
    }
    function markAvailability(opts) {
      $$('fieldset.option', root).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var v = findVariant(test);
          input.classList.toggle('unavailable', !v || !v.available);
        });
      });
    }
    function update() {
      var opts = selected();
      var v = findVariant(opts);
      markAvailability(opts);
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-unavailable'); return;
      }
      idInput.value = v.id;
      var html = '<span class="price__current">' + money(v.price) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) html += '<s class="price__compare">' + money(v.compare_at_price) + '</s>';
      priceEl.innerHTML = html;
      priceEl.classList.toggle('price--sale', !!(v.compare_at_price && v.compare_at_price > v.price));
      addBtn.disabled = !v.available;
      if (!v.available) addBtn.setAttribute('data-sold-out', ''); else addBtn.removeAttribute('data-sold-out');
      addBtn.textContent = v.available ? addBtn.getAttribute('data-add') : addBtn.getAttribute('data-sold');
      if (availEl) availEl.textContent = v.available ? availEl.getAttribute('data-in') : availEl.getAttribute('data-out');
      if (v.featured_media) setImage(v.featured_media.preview_image.src + (v.featured_media.preview_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1400', v.featured_media.id);
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    $$('fieldset.option input', root).forEach(function (i) { i.addEventListener('change', update); });
    $$('.product__thumbs button', root).forEach(function (t) {
      t.addEventListener('click', function () { setImage(t.getAttribute('data-src'), t.getAttribute('data-media-id')); });
    });
    if ($$('fieldset.option', root).length) markAvailability(selected());
  });

  /* Collection sort */
  $$('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var url = new URL(window.location.href); url.searchParams.set('sort_by', s.value); url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
})();
